// Diff view: a proposal against what the record holds now, field by field (agent-authored side tinted violet).
import type { ReactNode } from "react";

export function DiffView({ before, after, beforeLabel = "Now", afterLabel = "Proposed" }: {
  before: Record<string, unknown> | null | undefined; after: Record<string, unknown> | null | undefined; beforeLabel?: string; afterLabel?: string;
}) {
  const keys = [...new Set([...Object.keys(before ?? {}), ...Object.keys(after ?? {})])];
  if (!keys.length) return <p className="text-sm text-muted">No field changes published for this item.</p>;
  const show = (v: unknown): ReactNode => (v === null || v === undefined || v === "" ? <span className="italic text-muted">empty</span> : typeof v === "object" ? JSON.stringify(v) : String(v));
  return (
    <table className="w-full text-[13px]" aria-label="Proposed changes">
      <thead className="text-left text-xs text-muted"><tr><th className="py-1 pr-2 font-medium">Field</th><th className="py-1 pr-2 font-medium">{beforeLabel}</th><th className="py-1 font-medium">{afterLabel}</th></tr></thead>
      <tbody className="divide-y divide-line">
        {keys.map((k) => {
          const b = before?.[k], a = after?.[k];
          const changed = JSON.stringify(b) !== JSON.stringify(a);
          return (
            <tr key={k}>
              <th scope="row" className="py-1.5 pr-2 text-left font-medium">{k}</th>
              <td className={`py-1.5 pr-2 font-mono ${changed ? "text-blocked line-through decoration-1" : ""}`}><span className="sr-only">{changed ? "removed: " : ""}</span>{show(b)}</td>
              <td className={`py-1.5 font-mono ${changed ? "rounded bg-agent-bg text-agent" : ""}`}><span className="sr-only">{changed ? "proposed: " : ""}</span>{show(a)}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
